module.exports = __webpack_public_path__ + "img/question.79bff40b.svg";